import { render, staticRenderFns } from "./LastMessages.vue?vue&type=template&id=7c723790"
import script from "./LastMessages.vue?vue&type=script&lang=js"
export * from "./LastMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports